class Pacts {
    public id: number;
    public id_conciliation: number;
    public date_pact: string;
    public attendance: boolean;
    public num_certificate: string;
    public agreement: string;
    public date_agreement: string;
    public type_debt: string;
    public value_pact: string;
    public reconciliation_amount_erp: string;
    public reconciliation_amount_ebp: string;
    public gloss_acepted_ebp: string;
    public gloss_corrected_erp: string;
    public gloss_unresolved: string;
    public value_reconciled: string;
    public date_commitment_payment: string;
    public value_payment: string;
    public is_active: string;

    constructor(
        id: number,
        date_pact: string,
        attendance: boolean,
        num_certificate: string,
        agreement: string,
        date_agreement: string,
        type_debt: string,
        value_pact: string,
        reconciliation_amount_erp: string,
        reconciliation_amount_ebp: string,
        gloss_acepted_ebp: string,
        gloss_corrected_erp: string,
        gloss_unresolved: string,
        value_reconciled: string,
        date_commitment_payment: string,
        value_payment: string,
        is_active: string,
        id_conciliation: number,
    ){
        this.id = id;
        this.date_pact = date_pact;
        this.attendance = attendance;
        this.num_certificate = num_certificate;
        this.agreement = agreement;
        this.date_agreement = date_agreement;
        this.type_debt = type_debt;
        this.value_pact = value_pact;
        this.reconciliation_amount_erp = reconciliation_amount_erp;
        this.reconciliation_amount_ebp = reconciliation_amount_ebp;
        this.gloss_acepted_ebp = gloss_acepted_ebp;
        this.gloss_corrected_erp = gloss_corrected_erp;
        this.gloss_unresolved = gloss_unresolved;
        this.value_reconciled = value_reconciled;
        this.date_commitment_payment = date_commitment_payment;
        this.value_payment = value_payment;
        this.is_active = is_active;
        this.id_conciliation = id_conciliation;
    }


  }
  
  export default Pacts;
  